// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lessonOption
{
    width: 70%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    resize: vertical;
}
.lessonPlan
{
    width: 30%;
    height: auto;
    border-radius: 5vh;
    background-color: #bbf0fa;
    padding:3%;
    margin-left: 2%;
}
.Inp
{
    width: 30%;
    height: auto;
    border: 0;
    border-radius: 1vh; 
    padding: 2%;
}
.sendBtn
{
    width: 30%;
    padding: 12px;
    background-color: #03b4c6;
    color: white;
    font-weight: bold;
    margin: 2%;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    resize: vertical;
}
.joinBtn
{
    border: 0;
    background-color:#bbf0fa ;
    color: #03b4c6;
    padding: 2vh 10vh 2vh 10vh;
    font-size: 4vh;
    border-radius: 2vh;
    margin: 2%;
}
.LessonActivities
{ 
    font-size: 3vh;
    word-wrap: break-word;
    cursor: pointer;
}
.LessonActivities:hover{
    color: #0c6b75;
}
.ActivitiesLogo
{
   width: 10%;
   height: auto;
   margin: 1vh;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(-20px); }
  100% { opacity: 1; transform: translateY(0); }
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/Actions/TeacherAttendClass.css"],"names":[],"mappings":"AAAA;;IAEI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;;IAEI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,eAAe;AACnB;AACA;;IAEI,UAAU;IACV,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;AACA;;IAEI,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;;IAEI,SAAS;IACT,yBAAyB;IACzB,cAAc;IACd,0BAA0B;IAC1B,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;AACA;;IAEI,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;;GAEG,UAAU;GACV,YAAY;GACZ,WAAW;AACd;AACA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C","sourcesContent":[".lessonOption\n{\n    width: 70%;\n    padding: 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box;\n    resize: vertical;\n}\n.lessonPlan\n{\n    width: 30%;\n    height: auto;\n    border-radius: 5vh;\n    background-color: #bbf0fa;\n    padding:3%;\n    margin-left: 2%;\n}\n.Inp\n{\n    width: 30%;\n    height: auto;\n    border: 0;\n    border-radius: 1vh; \n    padding: 2%;\n}\n.sendBtn\n{\n    width: 30%;\n    padding: 12px;\n    background-color: #03b4c6;\n    color: white;\n    font-weight: bold;\n    margin: 2%;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box;\n    resize: vertical;\n}\n.joinBtn\n{\n    border: 0;\n    background-color:#bbf0fa ;\n    color: #03b4c6;\n    padding: 2vh 10vh 2vh 10vh;\n    font-size: 4vh;\n    border-radius: 2vh;\n    margin: 2%;\n}\n.LessonActivities\n{ \n    font-size: 3vh;\n    word-wrap: break-word;\n    cursor: pointer;\n}\n.LessonActivities:hover{\n    color: #0c6b75;\n}\n.ActivitiesLogo\n{\n   width: 10%;\n   height: auto;\n   margin: 1vh;\n}\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translateY(-20px); }\n  100% { opacity: 1; transform: translateY(0); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
